import(/* webpackMode: "eager" */ "/var/www/ITSCoupons/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/ITSCoupons/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/app/public/blogs/[slug]/BlogClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/app/public/blogs/[slug]/BlogNotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/app/public/events/[slug]/EventClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/app/public/events/[slug]/EventNotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/app/public/stores/[slug]/StoreNotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdBillboard","AdRectangle2","AdRectangle1"] */ "/var/www/ITSCoupons/src/components/ads/GptAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/Blogs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/BlogSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/BravoDealInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/categories/Categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/categories/CategoriesSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/coupons/AllCouponsPage.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/ITSCoupons/src/components/coupons/RelatedStores.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/Events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/EventSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/FeaturedStores.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/ITSCoupons/src/components/genericPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/HeroSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/Newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/PromoCodesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/StoreData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/StoreList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/StoresComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/StoresDirectory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/TopDeals.tsx");
